import React from "react";
import { useChatInputTextStyles } from "./styles";
import {
  Button,
  Caption1,
  Dropdown,
  Option,
  OptionOnSelectData,
  SelectionEvents,
  Spinner,
  Textarea,
  TextareaOnChangeData,
  tokens,
} from "@fluentui/react-components";
import { RecordStopRegular, SendFilled } from "@fluentui/react-icons";
import { Stack } from "../stack";

interface ChatInputTextProps {
  placeholder?: string;
  query: string;
  onQueryChange: (ev: React.ChangeEvent<HTMLTextAreaElement>, data: TextareaOnChangeData) => void;
  dropdown?: {
    documentExcerptOption: string;
    selectedDocumentExcerpt: string[];
    onDocumentExcerptChange: (event: SelectionEvents, data: OptionOnSelectData) => void;
  };
  sendBtn: {
    disabled?: boolean;
    onClick: () => void;
  };
  stopBtn: {
    disabled?: boolean;
    onClick: () => void;
  };
  loading?: boolean;
  error?: string;
}

export default function ChatInputText({
  query,
  onQueryChange,
  dropdown,
  sendBtn,
  stopBtn,
  loading,
  error,
  placeholder,
}: ChatInputTextProps) {
  const styles = useChatInputTextStyles();
  return (
    <div>
      <div className={styles.textAreaContainer}>
        <Textarea
          value={query}
          onChange={onQueryChange}
          className={styles.textArea}
          placeholder={placeholder || "Ask a question"}
          size="large"
        />
        <div className={styles.dropdownContainer}>
          {dropdown && (
            <Dropdown
              value={dropdown.documentExcerptOption}
              selectedOptions={dropdown.selectedDocumentExcerpt}
              onOptionSelect={dropdown.onDocumentExcerptChange}
              className={styles.dropdown}
            >
              <Option text="Full Document" value="full-document">
                Full Document
              </Option>
              <Option text="Selected Text" value="selected-text">
                Selected Text
              </Option>
            </Dropdown>
          )}
          <Stack align="center" gap="0.5rem" style={{ marginLeft: "auto" }}>
            <Button
              shape="circular"
              appearance="primary"
              aria-label="Cancel request"
              disabled={stopBtn.disabled}
              icon={<RecordStopRegular />}
              onClick={stopBtn.onClick}
            />
            <Button
              shape="circular"
              appearance="primary"
              aria-label="Send request"
              disabled={sendBtn.disabled}
              className={styles.sendBtn}
              icon={loading ? <Spinner size="extra-tiny" /> : <SendFilled />}
              onClick={sendBtn.onClick}
            />
          </Stack>
        </div>
      </div>
      {error && <Caption1 style={{ color: tokens.colorPaletteRedForeground1 }}>{error}</Caption1>}
    </div>
  );
}
